import React from 'react';

export const DATE_FORMAT = 'dd-MM-yyyy';
export const OFFER_DATE_FORMAT = 'do MMMM yyyy';
export const DATE_FORMAT_WITH_TIME = 'dd-MM-yyyy HH:mm:ss';

export function now() {
  return new Date();
}

export function nowTimestamp() {
  return now().getTime();
}

